import { useEffect, useState } from "react";
import { Wind } from "lucide-react";
import { BRAND } from "@/data/product";

const LINKS = [
    { label: "Shop", href: "#shop" },
    { label: "Why It Wins", href: "#why" },
    { label: "Cooling Tech", href: "#cooling" },
    { label: "Reviews", href: "#reviews" },
    { label: "FAQ", href: "#faq" },
];

export default function Navbar({ onBuy }) {
    const [scrolled, setScrolled] = useState(false);

    useEffect(() => {
        const onScroll = () => setScrolled(window.scrollY > 40);
        window.addEventListener("scroll", onScroll, { passive: true });
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    return (
        <header
            data-testid="navbar"
            className={`fixed top-0 inset-x-0 z-40 transition-[background-color,border-color,backdrop-filter] duration-500 ${
                scrolled ? "backdrop-blur-2xl bg-black/60 border-b border-white/10" : "bg-transparent border-b border-transparent"
            }`}
        >
            <div className="max-w-7xl mx-auto px-5 md:px-10 h-16 flex items-center justify-between">
                <a href="#top" data-testid="nav-logo" className="flex items-center gap-2 group">
                    <Wind className="w-5 h-5 text-cyan-300 transition-transform duration-500 group-hover:rotate-180" />
                    <span className="font-display font-600 tracking-[0.25em] text-sm uppercase">{BRAND}</span>
                </a>
                <nav className="hidden md:flex items-center gap-8" data-testid="nav-links">
                    {LINKS.map((l) => (
                        <a
                            key={l.href}
                            href={l.href}
                            data-testid={`nav-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                            className="text-xs uppercase tracking-[0.18em] text-zinc-400 hover:text-white transition-colors duration-300"
                        >
                            {l.label}
                        </a>
                    ))}
                </nav>
                <button
                    onClick={onBuy}
                    data-testid="nav-buy-button"
                    className="rounded-full bg-cyan-300 text-black text-xs font-bold uppercase tracking-[0.15em] px-5 py-2.5 transition-transform duration-300 hover:scale-105 glow-btn"
                >
                    Buy Now
                </button>
            </div>
        </header>
    );
}
